<template>
  <a-modal :width="1450" :visible="visible" :footer="null" style="height: 100%; overflow: hidden" @cancel="() => {
    $emit('cancel');
  }
    ">
    <a-spin :spinning="dataLoading">
      <div>
        <a-input-search style="margin-left: 550px; width: 320px; margin-bottom: 30px" placeholder="请输入文件名"
          v-model="queryParam.name" @search="search" @keyup.enter.native="search" />
      </div>

      <a-list :grid="{ gutter: 16, column: 4 }" class="clear">
        <a-list-item :key="index" v-for="(item, index) in fileData">
          <a-card :hoverable="true" :class="[card == 1 ? 'card' : 'card2']" ref="cards" style="margin-left: 60px">
            <img slot="cover" :alt="item.name" :width="item.imageWidth" :height="item.imageHeight"
              :src="buildFilePath(item.imageUrl)" @click="viewerItem2(index)" />
            <a-card-meta :title="item.name"> </a-card-meta>
          </a-card>
        </a-list-item>
        <div v-if="fileData.length > 0">
          <!--TODO 此处空div主要为了解决父div高度为0，导致页面布局混乱-->
        </div>
      </a-list>

      <div class="page">
        <a-pagination v-model="current" :page-size-options="['8', '16', '24', '32', '40', '48', '96']" :total="total"
          :show-total="(total) => `共计 ${total} 项`" show-size-changer :page-size="queryParam.pageSize"
          @showSizeChange="onShowSizeChange" @change="changePage">
          <template slot="buildOptionText" slot-scope="props">
            <span v-if="props.value !== '50'">{{ props.value }}条/页</span>
            <span v-if="props.value === '50'">全部</span>
          </template>
        </a-pagination>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>
import { requestUrl } from "@/utils/request_url";
import * as task from "@api/task_management";

export default {
  name: "TrainValidate",
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
    validate: {
      type: Object,
      default: () => null,
    },
    visible: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      zoomNum: null,
      card: 1,
      dataLoading: "",
      fileData: [],
      current: 1,
      total: 0,
      queryParam: {
        pageIndex: 1,
        pageSize: 8,
        name: "",
        taskId: "",
      },
      urlData: [],
      flag: false,
      views: null,
      index: 0,
    };
  },
  created() {
    this.dataLoading = this.loading;
    this.$watch("validate", () => {
      this.queryParam.taskId = this.validate.currentTaskId;
      this.init();
      this.loadAll();
    });
  },
  watch: {},
  computed: {},
  mounted() {
    const that = this;
    that.zoomNum = that.detectZoom();
    if (that.zoomNum > 125) {
      that.card = 2;
    } else {
      that.card = 1;
    }
    window.onresize = function () {
      that.zoomNum = that.detectZoom();
      if (that.zoomNum > 125) {
        that.card = 2;
      } else {
        that.card = 1;
      }
    };

    //监听 键盘方向键 左右按键
    document.onkeydown = function (event) {
      const { index } = that;
      var e = event || window.event || arguments.callee.caller.arguments[0];
      if (!that.flag) {
        return;
      }
      //上一张
      if (e && e.keyCode == 37) {
        console.log("左", index);

        //判断是否到头了
        if (index == 0) return;
        that.views.toogleImg(false, "btn");
      }
      if (e && e.keyCode == 39) {
        if (index == that.urlData.length - 1) return;
        that.views.toogleImg(true, "btn");
      }
    };

  },
  methods: {
    //上一页
    prvNext() {
      if (this.current > 1) {
        this.current--;
        this.changePage(this.current, this.queryParam.pageSize);
      }
    },
    //下一页
    next() {
      let totalPage = Math.ceil(this.total / this.queryParam.pageSize);
      if (this.current < totalPage) {
        this.current++;
        this.changePage(this.current, this.queryParam.pageSize);
      }
    },
    // 查询页面缩放比例
    detectZoom() {
      var ratio = 0,
        screen = window.screen,
        ua = navigator.userAgent.toLowerCase();

      if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio;
      } else if (ua.indexOf("msie")) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
          ratio = screen.deviceXDPI / screen.logicalXDPI;
        }
      } else if (
        window.outerWidth !== undefined &&
        window.innerWidth !== undefined
      ) {
        ratio = window.outerWidth / window.innerWidth;
      }
      if (ratio) {
        ratio = Math.round(ratio * 100);
      }
      return ratio;
    },

    viewerItem2(index) {
      this.index = index;
      this.flag = true;
      this.views = this.$hevueImgPreview({
        multiple: true,
        nowImgIndex: index,
        imgList: this.urlData,
        changeFn: ({ fromImgIndex, toImgIndex, type }) => {

        },
        closeFn: () => {

        },
      });
    },

    search() {
      this.init();
    },

    changePage(page, pageSize) {
      this.queryParam.pageIndex = page;
      this.init();
    },
    onShowSizeChange(current, pageSize) {
      this.queryParam.pageSize = pageSize;
      this.init();
    },

    buildFilePath(fileName) {
      var file = "";
      file = fileName.replace(/#/g, "%23");
      return requestUrl + file;
    },
    loadAll() {
      task
        .getTrainVerifyPage({
          ...this.queryParam,
          pageIndex: 1,
          pageSize: 100,
        })
        .then((res) => {
          for (let index = 0; index < res.data.list.length; index++) {
            const element = res.data.list[index];
            this.urlData.push(requestUrl + element.imageUrl);
          }
        });
    },
    init() {
      const self = this;
      this.fileData = [];

      task
        .getTrainVerifyPage(this.queryParam)
        .then((res) => {
          self.total = res.data.totalRecords;
          let param1 = this.zoomNum <= 125 ? 215 : 180;
          let param2 = this.zoomNum <= 125 ? 200 : 150;

          for (let index = 0; index < res.data.list.length; index++) {
            const element = res.data.list[index];

            var w = element.width;
            var h = element.height;
            element.realHeight = h;
            element.realWidth = w;
            if (w > h) {
              if (w > param1) {
                const scale = w / h;
                if (param1 / scale > param2) {
                  element.imageHeight = param2 + "px";
                  element.imageWidth = param2 * scale + "px";
                } else {
                  element.imageHeight = param1 / scale + "px";
                  element.imageWidth = param1 + "px";
                }
              }
            } else {
              if (h > param2) {
                const scale = h / param2;
                element.imageHeight = param2 + "px";
                element.imageWidth = w / scale + "px";
              }
            }
            self.fileData.push(element);
          }
          self.dataLoading = false;


        })
        .catch(() => console.log("小猪，出错啦，休息会吧!"));
    },
  },
};
</script>
<style scoped lang="scss">
.card {
  height: 290px;
  width: 220px;

}

.card2 {
  width: 220px;
  height: 250px;
}

.page {
  text-align: right;
}

.ant-card {
  ::v-deep .ant-card-meta-title {
    font-size: 16px;
    font-weight: normal;
    white-space: normal;
    text-overflow: initial;
  }
}

.clear:after {
  content: "";
  display: block;
  clear: both;
}
</style>